import {pluralize} from "@pg-mono/string-utils";

export const flatTextPluralize = pluralize(["mieszkanie", "mieszkania", "mieszkań"]);

export const houseTextPluralize = pluralize(["dom", "domy", "domów"]);

export const personTextPluralize = pluralize(["osoba", "osoby", "osób"]);

export const garagesTextPluralize = pluralize(["garaż", "garaże", "garaży"]);

export const viewsTextPluralize = pluralize(["oglądała", "oglądały", "oglądało"]);
import {pluralize} from "@pg-mono/string-utils";

export const flatTextPluralize = pluralize(["mieszkanie", "mieszkania", "mieszkań"]);

export const houseTextPluralize = pluralize(["dom", "domy", "domów"]);

export const personTextPluralize = pluralize(["osoba", "osoby", "osób"]);

export const garagesTextPluralize = pluralize(["garaż", "garaże", "garaży"]);

export const viewsTextPluralize = pluralize(["oglądała", "oglądały", "oglądało"]);
